import Text from 'components/Text/Text';
import React, { useContext, useEffect, useState } from 'react';
import { RequestEntity } from 'types';
import { PRE_SELECTED_CUSTOMER_ID_FOR_MENU } from 'appConstants';
import { Dropdown, Menu } from 'antd';
import { AppContext, IAppContext } from 'appState/appContext';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Link } from 'react-router-dom';
import ImgUploaderByEntityId from '../../../../components/ImgUploader/ImgUploaderByEntityId';
import classNames from 'classnames';
import style from './UserProfileDropdown.module.scss';

const UserProfileDropdown: React.FC = () => {
	const { loggedUser } = useContext<IAppContext>(AppContext);

	const [open, setOpen] = useState<boolean>(false);
	const [makeForcedReload, setMakeForcedReload] = useState(false);

	const arrowClasses = classNames(style.arrow, { [style.arrowActive]: open });

	const getDefaultAvatar = () => {
		const role = loggedUser.role;

		return (
			<svg className={style.icon}>
				<use xlinkHref={`${breadcrumbs}#userAvatar${role}`} />
			</svg>
		);
	};

	const defaultAvatar = getDefaultAvatar();

	const handleLogOut = () => {
		localStorage.removeItem('accessToken');
		localStorage.removeItem('refreshToken');
		localStorage.removeItem(PRE_SELECTED_CUSTOMER_ID_FOR_MENU);
		location.reload();
	};

	const toggleOpen = () => {
		setOpen((prevState) => !prevState);
	};

	useEffect(() => {
		// trigger state to rerender img uploader after changing user avatar
		setMakeForcedReload((prevState) => !prevState);
	}, [loggedUser]);

	const menu = (
		<Menu className={style.menu}>
			<Menu.Item data-test="dropdown-item-profile" key="userProfile" className={style.menuItem}>
				<Link to="/users/me" onClick={toggleOpen}>
					<svg className={style.dropDownIcon}>
						<use xlinkHref={`${breadcrumbs}#userProfile`} />
					</svg>
					<Text translationNameSpace="global" translationKey="profile" asFragment={true} />
				</Link>
			</Menu.Item>
			<Menu.Item data-test="dropdown-item-logOut" key="logOut" className={style.menuItem} onClick={handleLogOut}>
				<svg className={style.dropDownIcon}>
					<use xlinkHref={`${breadcrumbs}#logOut`} />
				</svg>
				<Text translationNameSpace="global" translationKey="logOut" asFragment={true} />
			</Menu.Item>
		</Menu>
	);

	return (
		<Dropdown overlay={menu} placement="bottomRight" trigger={['click']} onVisibleChange={toggleOpen}>
			<div className={style.iconContainer} data-test="dropdown-profile">
				<div className={style.imgWrapper}>
					{loggedUser.filePath ? (
						<ImgUploaderByEntityId
							resource={RequestEntity.Users}
							entityID={loggedUser.userId}
							photoSize="Small"
							makeForcedReload={makeForcedReload}
							loaderSize="avatar"
						/>
					) : (
						defaultAvatar
					)}
				</div>
				<svg className={arrowClasses}>
					<use xlinkHref={`${breadcrumbs}#caretDown`} />
				</svg>
			</div>
		</Dropdown>
	);
};

export default UserProfileDropdown;
